import { ref, onMounted, onUnmounted } from 'vue'

export function useBitrix24Responsive() {
  const isBitrix24 = ref(false)
  const iframeWidth = ref(window.innerWidth)
  const iframeHeight = ref(window.innerHeight)
  const scale = ref(1)

  // Определяем, работаем ли в Bitrix24
  const checkBitrix24Context = () => {
    isBitrix24.value = typeof window.BX24 !== 'undefined' && localStorage.getItem('bitrix24_mode') === 'true'
  }

  // Вычисляем масштаб на основе ширины
  const calculateScale = () => {
    if (!isBitrix24.value) {
      scale.value = 1
      return
    }

    // Если ширина меньше 1200px, применяем масштабирование
    if (iframeWidth.value < 1200) {
      scale.value = iframeWidth.value / 1200
    } else {
      scale.value = 1
    }
  }

  // Обработчик изменения размера окна
  const handleResize = () => {
    iframeWidth.value = window.innerWidth
    iframeHeight.value = window.innerHeight
    calculateScale()
    applyBitrix24Styles()
  }

  // Применяем стили для Bitrix24
  const applyBitrix24Styles = () => {
    if (!isBitrix24.value) return

    const html = document.documentElement
    const body = document.body

    // Устанавливаем атрибут для CSS селекторов
    html.setAttribute('data-bitrix24-mode', 'true')

    // Убираем горизонтальный скролл
    html.style.overflow = 'hidden'
    body.style.overflow = 'hidden'

    // Применяем масштабирование
    if (scale.value < 1) {
      html.style.transform = `scale(${scale.value})`
      html.style.transformOrigin = 'top left'
      html.style.width = `${100 / scale.value}%`
      html.style.height = `${100 / scale.value}%`
    }

    // Скрываем элементы, которые не нужны в Bitrix24
    const elementsToHide = [
      '.dev-mode-indicator',
      '.dev-tools-panel',
    ]

    elementsToHide.forEach(selector => {
      const elements = document.querySelectorAll(selector)
      elements.forEach(el => {
        el.style.display = 'none'
      })
    })
  }

  // Сообщаем Bitrix24 о размере контента
  const notifyBitrix24Resize = () => {
    if (!isBitrix24.value) return

    try {
      // Получаем реальную высоту контента
      const contentHeight = document.documentElement.scrollHeight
      const contentWidth = document.documentElement.scrollWidth

      // Отправляем команду родительскому окну
      window.parent.postMessage({
        type: 'RESIZE_WINDOW',
        width: contentWidth,
        height: contentHeight
      }, '*')
    } catch (err) {
      console.warn('⚠️ Ошибка при отправке команды изменения размера:', err)
    }
  }

  // Инициализация
  onMounted(() => {
    checkBitrix24Context()
    calculateScale()
    applyBitrix24Styles()
    notifyBitrix24Resize()

    // Слушаем изменения размера
    window.addEventListener('resize', handleResize)

    // Слушаем изменения DOM для пересчёта размера
    const observer = new MutationObserver(() => {
      notifyBitrix24Resize()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    })

    return () => {
      observer.disconnect()
    }
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })

  return {
    isBitrix24,
    iframeWidth,
    iframeHeight,
    scale,
  }
}
